/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { headerDetails } from '../../../modules/graphql/index';
import { PageParamsContext } from '../../../modules/context/PageContext';
import { LocalHeaderDataProps } from '../LocalHeader.types';
import { localheaderMockUXL } from '../__mock__/LocalHeaderMock';

export const LocalHeaderData: FC<LocalHeaderDataProps> = pageProps => {
  const { preProcessorResponse, lang, sessionID, requestId } = useContext(PageParamsContext);

  const { isAuthorMode, onLocalHeaderDataFetched } = pageProps;
  const isServer = !(typeof window != 'undefined' && window.document);

  let { data, loading } = useQuery(headerDetails, {
    fetchPolicy: isServer ? 'network-only' : 'cache-first',
    variables: {
      propertyId: preProcessorResponse?.marsha ?? '',
      filter: 'PHONE',
    },
    context: {
      headers: {
        //Update the variables of AriesReservation for ppv5
        'accept-language': lang ?? 'en-US',
        'x-b3-traceId': sessionID ?? 'fallback-token',
        'x-b3-spanId': requestId !== '' ? requestId : `${Date.now()}`,
        'correlation-id': sessionID ?? 'fallback-token',
      },
    },
    skip: isAuthorMode,
  });

  if (isAuthorMode) {
    loading = false;
    data = localheaderMockUXL;
  }

  useEffect(() => {
    if (!loading && data) {
      onLocalHeaderDataFetched({ ...data });
    }
  }, [loading, data, onLocalHeaderDataFetched]);

  return null;
};
